module.exports = Object.freeze({
    NONE: 'none',
    COORDINATOR: 'coordinator',
    GIVER: 'giver',
    RECEIVER: 'receiver',
    OWNER: 'owner',
});
